module.exports = __webpack_public_path__ + "static/media/turkish-people.71432704.svg";